import { useReportInsights } from "features/reports/hooks/useReportInsights";
import { isInsightsSupportedReportType } from "features/reports/utils/isInsightsSupportedReportType";

import { AccountingInsights } from "./AccountingInsights";
import { AppointmentsInsights } from "./AppointmentsInsights";
import { AuditLogInsights } from "./AuditLogInsights";
import { ConsultationsInsights } from "./ConsultationsInsights";
import { ImmunisationsInsights } from "./ImmunisationsInsights";
import { InvestigationsInsights } from "./InvestigationsInsights";
import { LettersInsights } from "./LettersInsights";
import { PrescriptionsInsights } from "./PrescriptionsInsights";

const INSIGHTS_COMPONENT_BY_TYPE = {
  immunisations: ImmunisationsInsights,
  prescriptions: PrescriptionsInsights,
  investigations: InvestigationsInsights,
  letters: LettersInsights,
  accounting: AccountingInsights,
  appointments: AppointmentsInsights,
  "audit-log": AuditLogInsights,
};

export const ReportInsights = ({ reportType, filters, tenantVal }) => {
  const { insights, isLoading } = useReportInsights({ tenantVal, reportType, filters });

  if (!isInsightsSupportedReportType(reportType)) {
    return null;
  }

  const InsightsComponent = INSIGHTS_COMPONENT_BY_TYPE[reportType] ?? ConsultationsInsights;

  return <InsightsComponent insights={insights} isLoading={isLoading} />;
};
